import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { IHeroBlockProps } from "./HeroBlock.props";

export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) return null;
  return (
    <AbyssSection
      className={props.parentClass}
      containerWidth="wide"
      id={props.anchorId}
      spacing={props.spacing}
    >
      {props.variant === "split-image" ? (
        <HeroSplitImage {...props} />
      ) : (
        <HeroBackgroundImage {...props} />
      )}
    </AbyssSection>
  );
};

HeroBlock.displayName = "Block::HeroBlock";
